import React, { useRef, useEffect, useState, useCallback } from "react";
import {
    TableBody,
    TableCell,
    TableRow,
    Table,
    Spinner,
    makeStyles,
  } from "@fluentui/react-components";
import {
    Person24Regular,
    Location24Regular,
    Call24Regular,
    Mail24Regular,
    AccessibilityCheckmark24Regular,
    Flag24Regular,
    BuildingTownhouse24Regular
  } from "@fluentui/react-icons";  
import { customTokens } from "../../utils/Theming";
import { safeAddress } from "../../utils/Helpers";
import useSize from "@react-hook/size";
import { useDispatch, useSelector } from "react-redux";

import { fetchRelationContactRelation } from "./relationContactRelation-slice";
import { setRelationContactRelationOoid } from "./relationContactRelation-slice";

function getGenderFullName(short_code) {
    let name = 'Other';

    if(short_code === 'M') {
        name = 'Male';
    }

    if(short_code === 'F') {
        name = 'Female';
    }

    return name;
}

const useStyles = makeStyles({
    label: {
        display: 'flex',
        alignItems: 'center',
    },
    labelContent: {
        display: 'inline-block',
        paddingLeft: '15px',
        position: 'relative',
        top: '-2px',
        color: customTokens.colorNeutralForeground2
    },
    fontSmall: {
        fontSize: customTokens.fontSizeBase300,
    }
});


export default function RelationContactRelationTable({relationContact: relationContact, context = 'canidate'}) {
    const {relationContactRelation} = useSelector(state => state.relationContactRelation);
    const dispatch = useDispatch();
    const classes = useStyles();
    const target = useRef(null);
    const [width, ] = useSize(target);

    let tableSize = 'small';
    if (width > 300){
        tableSize = 'medium'
    }

    let ooid = relationContact.relationId;

    useEffect(() => {
        dispatch(setRelationContactRelationOoid(ooid));
        dispatch(fetchRelationContactRelation());
    }, [ooid, dispatch]);


    const tableContent = [];

    if(relationContactRelation) {
        if (relationContact.relation) {
            tableContent.push({
                key: 'relationName',
                icon: <BuildingTownhouse24Regular />,
                label: relationContact.relation
            });
        }

        if (relationContactRelation.customerNr) {
            tableContent.push({
                key: 'customerNr',
                icon: <Flag24Regular />,
                label: relationContactRelation.customerNr
            });
        }
        if (relationContactRelation.email) {
            tableContent.push({
                key: 'email',
                icon: <Mail24Regular />,
                label: relationContactRelation.email
            });
        }
        if (relationContactRelation.website) {
            tableContent.push({
                key: 'website',
                icon: <Mail24Regular />,
                label: relationContactRelation.website
            });
        }

        if (relationContactRelation.Addresses.main) {            
            const address = safeAddress(', ', relationContactRelation.Addresses.main.address, [relationContactRelation.Addresses.main.city, relationContactRelation.Addresses.main.postcode], relationContactRelation.Addresses.main.country);
            if (address !== ''){
                tableContent.push({
                    key: 'address',
                    icon: <Location24Regular />,
                    label: address,
                });
            }
        }

        if (relationContactRelation.phoneNumberMain) {
            tableContent.push({
                key: 'phoneNumberMain',
                icon: <Call24Regular />,
                label: relationContactRelation.phoneNumberMain,
            });
        }

        /*
        if(relationContact.Person.PhoneNumbers) {
            for (let phone_key in relationContact.Person.PhoneNumbers) {
                let phone = relationContact.Person.PhoneNumbers[phone_key];
                if(phone.phoneNumber) {
                    tableContent.push({
                        key: 'phoneNumber',
                        icon: <Call24Regular />,
                        label: phone.phoneNumber + (phone.type ? (' (' + phone.type + ')') : '')
                    });
                }
            }
        }
        */

    }



    /*
    if (candidate) {
        if (context === 'procedure') {
            tableContent.push({
                key: 'name',
                icon: <Person24Regular />,
                label: candidate.Person.firstName  + (candidate.Person.infix ? (' ' + candidate.Person.infix) : '') + ' ' + candidate.Person.lastName
            })
        }
        if (candidate.Person.AddressPrimary) {
            const location = safeAddress(', ', candidate.Person.AddressPrimary.address, [candidate.Person.AddressPrimary.city, candidate.Person.AddressPrimary.postcode], candidate.Person.AddressPrimary.country);
            if (location) {
                tableContent.push({
                    key: 'location',
                    icon: <Location24Regular />,
                    label: location
                });
            }
        
        }
        if (candidate.Person.phoneMobile) {
            tableContent.push({
                key: 'phoneMobile',
                icon: <Call24Regular />,
                label: candidate.Person.phoneMobile
            });
        }
        if (candidate.Person.emailPrimary) {
            tableContent.push({
                key: 'emailPrimary',
                icon: <Mail24Regular />,
                label: candidate.Person.emailPrimary
            });
        }
        if (candidate.Person.gender) {
            tableContent.push({
                key: 'gender',
                icon: <AccessibilityCheckmark24Regular />,
                label: getGenderFullName(candidate.Person.gender)
            });
        }
        tableContent.push({
            key: 'nationality',
            icon: <Flag24Regular />,
            label: candidate.Person.nationality ? candidate.Person.nationality : 'Unknown'
        });
    }
    */

    let componentContent = <Spinner label="I am definitely loading..." />;

    if(relationContact) {
        componentContent = (
            <Table size={tableSize} className={width > 275 ? '': classes.fontSmall}>
                <TableBody>
                    {tableContent.map((item) => (
                        <TableRow key={item.key}>
                            <TableCell className={classes.label}>
                                {item.icon}
                                <div className={classes.labelContent}>
                                    {item.label}
                                </div>
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        );    
    }

    return (
        <div ref={target}>
            {componentContent}
        </div>
    );
}